<template>
    <div class="footer-content">
        <div v-if="appLanguages" class="language-selector">
            <a
                v-for="lang in appLanguages"
                @click.prevent="changeSelectedLanguage(lang.code)"
                class="me-2 pe-2"
                href="#"
                :class="{
                    'active text-blue-700':
                        lang.code.toLowerCase() === selectedLanguage,
                }"
                :key="lang.code"
                :aria-label="lang.label"
            >
                {{ lang.code }}
            </a>
        </div>
        <ul class="footer-links m-0 p-0">
            <li v-if="currentSite">
                {{ currentSite.toUpperCase() }}, {{ currentYear }}
            </li>
            <li>
                <a target="cookies" href="./cookies" :aria-label="$t('lib_cookies')">
                    {{ $t('lib_cookies') }}
                </a>
            </li>
            <li>
                <a target="_blank" :href="privacyUrl" :aria-label="$t('privacy_declaration')">
                    {{ $t('privacy_declaration') }}
                </a>
            </li>
            <li>
                {{ releaseVersion }}
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'AppFooter',
    components: {},
    data() {
        return {};
    },
    props: {
        releaseVersion: {
            type: String,
            required: true,
            default: 'v.0.0',
        },
    },
    computed: {
        ...mapGetters([
            'appLanguages',
            'selectedLanguage',
            'currentSite',
            'privacyUrl',
        ]),
        currentYear() {
            return new Date().getFullYear();
        },
    },
    methods: {
        ...mapActions(['changeSelectedLanguage']),
    },
};
</script>
